import React from 'react'

import s from './game-hub.module.less'

export const GameHubHeader = () => {
  return (
    <header className={s['hero-section']}>
      <nav className={s['navbar']}>
        <div className={s['nav-brand']}>
          <h3 className={s['brand-title']}>GameHub</h3>
        </div>
      </nav>
    </header>
  )
}
